// extracted by mini-css-extract-plugin
module.exports = {"emptyBox":"emptyBox___CDPp5","emptyText":"emptyText___3oAGZ"};